import type {BreadcrumbItem} from "@corporatesclub/shared";
import {Link} from "react-router-dom";

export function ProductCategoryTags({tags}: {tags: BreadcrumbItem[]}) {
  if(!tags.length) return null;
  return (
    <div className="pvCatTags" aria-label="Categories">
      {tags.map((tag) => (
        <Link key={tag.url} to={tag.url} className="pvCatTag anim">
          <span className="pvCatTagHash" aria-hidden="true">#</span>
          {tag.label}
        </Link>
      ))}
    </div>
  );
}
